// extracted by mini-css-extract-plugin
export default {"app":"app-PLtVp","main":"main-M8S_D"};